import { IconsMockApi } from '@sprint-expert/app/mock-api/ui/icons/api';

export const mockApiServices = [IconsMockApi];
